import { PipeTransform, Pipe } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';
import Address from '../model/project/address';
import { ProjectPlacement } from '../model/project/projectPlacement';

@Pipe({
  name: 'formatAppointmentTooltip'
})
export class FormatAppointmentTooltipPipe implements PipeTransform {
  transform(projectPlacement: ProjectPlacement) {
    if (projectPlacement != null) {
      let contact = null;
      if (projectPlacement.appointmentContact != null) {
        const mobileArr = projectPlacement.appointmentContact.telephones.filter(
          x => x.type === 'mobile' && x.number != null
        );
        const mobile =
          mobileArr != null && mobileArr.length > 0
            ? mobileArr[0].number
            : null;
        const telArr = projectPlacement.appointmentContact.telephones.filter(
          x => x.type === 'phone' && x.number != null
        );
        const tel =
          telArr != null && telArr.length > 0 ? telArr[0].number : null;
        const emailArr = projectPlacement.appointmentContact.emails.filter(
          x => x.email != null
        );
        const email =
          emailArr != null && emailArr.length > 0 ? emailArr[0].email : null;
        contact = StringHelper.join(
          [
            StringHelper.join(
              [
                'Makelaar:',
                projectPlacement.appointmentContact.firstName,
                projectPlacement.appointmentContact.lastName
              ],
              ' '
            ),
            tel,
            mobile,
            email
          ],
          ' - '
        );
      } else if (
        !StringHelper.isEmpty(projectPlacement.appointmentName) ||
        !StringHelper.isEmpty(projectPlacement.appointmentPhoneNumber) ||
        !StringHelper.isEmpty(projectPlacement.appointmentEmail)
      ) {
        contact =
          'Eigenaar/bewoner: ' +
          StringHelper.join(
            [
              projectPlacement.appointmentName,
              projectPlacement.appointmentPhoneNumber,
              projectPlacement.appointmentEmail
            ],
            ' - '
          );
      }
      return StringHelper.join(
        [projectPlacement.needAppointmentInfo, contact],
        '\n'
      );
    } else {
      return;
    }
  }
}

@Pipe({
  name: 'formatKeyTooltip'
})
export class FormatKeyTooltipPipe implements PipeTransform {
  transform(projectPlacement: ProjectPlacement) {
    if (projectPlacement != null) {
      let contact = null;
      if (projectPlacement['collectKeyFromAddress'] != null) {
        const collectKeyFromAddress: Address =
          projectPlacement['collectKeyFromAddress'];
        contact = StringHelper.join(
          [
            collectKeyFromAddress.addressee,
            StringHelper.join(
              [
                collectKeyFromAddress.line1,
                collectKeyFromAddress.postalCode +
                  ' ' +
                  collectKeyFromAddress.city
              ],
              ', '
            )
          ],
          ' - '
        );
      }
      return StringHelper.join(
        [projectPlacement.collectKeyExtraInfo, contact],
        '\n'
      );
    } else {
      return;
    }
  }
}
